import React from "react";
import Switch from "@material-ui/core/Switch";
import withStyles from "@material-ui/styles/withStyles";

const CustomizedSwitch = withStyles((theme) => ({
  root: {
    width: 48,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(10px)",
      color: "white !Important",
      "& + $track": {
        backgroundColor: "rgba(38, 187, 237, 1)",
        opacity: 1,
      },
    },
    "&$checked $thumb": {
      border: "1px solid rgba(38, 187, 237, 1)",
    },
  },
  thumb: {
    border: "1px solid rgba(153, 153, 153, 1)",
    width: 24,
    height: 24,
  },
  track: {
    transform: "translateX(1px)",
    borderRadius: 10,
    backgroundColor: "rgba(153, 153, 153, 1)",
    opacity: 1,
    width: 34,
    height: 12,
    marginTop: 8,
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default CustomizedSwitch;
